import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesList from './components/ServicesList';
import IndustriesSection from './components/IndustriesSection';

const ServicesPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ServicesHero />
        <ServicesList />
        <IndustriesSection />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;